import * as RouteNames from "@/employee/route-names";

export const footerTemplate = "AllegacyFooter";

export const investmentRiskDisclaimer = "Not NCUA Approved: The investment is not a deposit or obligation of, or guaranteed or endorsed by, any financial institution and is not insured by the Nation Credit Union Administration, the Federal Reserve Board, or any other U.S. governmental agency.";

export const displayMyProfileEditMode = false;

export const logoutRedirectUrl = null;

export const faqTemplate = "AllegacyForms";

export const faqInstructionsTemplate = "";

export const displayAdvice = true;

export const displayFaqExternalLinks = true;

export const displayFaqInstructions = true;

export const displayInvestmentsSection = true;

export const displaySettingsLinkedAccounts = true;

export const allowEmailEdit = false;

export const profileEditInformationHtml = "Please login to your Allegacy online account to make updates to locked information.";

export const priorYearContributionOption = true;

export const allowReimbursement = true;

export const showPendingReimbursements = true;

export const showAlternateOnboardingCompleteMessage = false;

export const disabledRouteRedirects = {
  [RouteNames.ContributionsEdit]: RouteNames.Contribution,
  [RouteNames.ManagePayrollContributions]: RouteNames.Contribution,
  [RouteNames.ContributionsManageOtherHsaAmounts]: RouteNames.Contribution,
  [RouteNames.ConfirmContribution]: RouteNames.Contribution
};

export const displayCashAccountMfaPopup = false;

export const termsUrl = "/allegacy_terms.pdf";

export const feeTemplate = "/Allegacy_Fee_Schedule_11_01_2024.pdf";

export const isFeeTemplateExternalUrl = true;

export const quarterlyPaperStatementFee = 2.25;

export const manageHsaCardsInPortal = false;

export const displayPriorYearContributionDisclaimerCopy = false;

export const displayProjectedContributions = true;

export const allowUserToEditContributions = true;

export const displayPdfForESign = true;

export const eSignPdfUrl = "/Allegacy_eSign_Disclosure_and_Consent.pdf";

export const displayFooterLegalSection = true;

export const contactDetailsSetAtBank = true;

export const allowFamilyMemberSsnInput = true;

export const showHsaStoreShopTab = true;

export const displayHealthcareClaims = true;

export const disableHsaInvestEnrollButtonAfterDate = "7/30/2025";

export const disablePortalFunctionalityAfterDate = "8/15/2025";

export const displayFdicBanner = false;

export const fdicDisclaimer = "";